<script setup lang="ts">
defineOptions({
  name: 'LayoutDefault',
})

</script>

<template>
  <main class="cs-auth">
    <slot />
  </main>
</template>
